import {
  ThreeDFILEIDRestService,
  ThreeDRestService,
  newGenericRestRequest,
} from './restServices';
import storageService from '../storageService';
import VIDABOO_CONSTANTS from '../../config/consts';
import httpService from './httpService';
import axios from 'axios';
const service = {};
service.controller = null;

service.createThreeD = async (createThreeD) => {
  try {
    const response = await ThreeDRestService.save(
      {
        endpoint: 'create',
      },
      {
        ...createThreeD,
        token: storageService.getItem('token'),
      },
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.debug(error);
  }
};

service.uploadFileToS3 = async (
  base64,
  tempAccessUrl,
  progress,
  cancelTokenCallback,
) => {
  try {
    const cancelTokenSource = httpService.cancelToken.source();
    cancelTokenCallback(cancelTokenSource);
    const response = await newGenericRestRequest(
      'put',
      VIDABOO_CONSTANTS.MEDIA_MESSAGES_STORAGE + tempAccessUrl,
      base64,
      {
        onUploadProgress: (progressEvent) =>
          progress(
            ((progressEvent.loaded / progressEvent.total) * 100).toFixed(2),
          ),
        cancelToken: cancelTokenSource.token,
      },
    );
    if (response.status === 200) {
      return true;
    }
    return false;
  } catch (error) {
    console.debug(error, 'Error in uploading file');
  }
};

service.getThreedFilesByObjectTypeAndObjectId = async (
  objectType,
  objectId,
  token,
) => {
  try {
    // const objectType = 'PERSONAL';

    const response = await ThreeDRestService.get(
      {
        endpoint: 'objectType',
        endpointParam: objectType,
        endpoint2: 'objectId',
        endpointParam2: objectId,
      },
      {token: token ? token : storageService.getItem('token')},
    );

    return response.data;
  } catch (error) {
    console.debug(error);
  }
};

// service.get3DFileByObjectType = async (objectId, token) => {
//   try {
//     const objectType = 'PERSONAL';

//     const response = await ThreeDFILEIDRestService.get({
//       endpoint: 'objectType',
//       endpointParam: objectType,
//       endpoint2: 'objectId',
//       endpointParam2: objectId,
//       token: token ? token : storageService.getItem('token'),
//     });

//     return response.data;
//   } catch (error) {
//     console.debug(error);
//   }
// };
service.getThreedFileByThreedFileId = async (fileId) => {
  try {
    const response = await ThreeDFILEIDRestService.get(
      {
        endpoint: 'threed',
        endpointParam: fileId,
      },
      {token: storageService.getItem('token')},
    );
    return response.data;
  } catch (error) {
    console.debug(error);
  }
};
service.deleteThreeDByFileId = async (fileId, token) => {
  try {
    const response = await ThreeDFILEIDRestService.delete(
      {
        endpoint: 'threed',
        endpointParam: fileId,
      },
      {
        token: token ? token : storageService.getItem('token'),
      },
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

service.update3DFileByField = async (fileId, threedFile) => {
  try {
    var threeDRequestObject = {
      token: storageService.getItem('token'),
      threedFileDto: threedFile,
    };
    const response = await ThreeDRestService.update(
      {
        endpointParam: fileId,
      },
      threeDRequestObject,
    ); // failure
    return response.data.threedFileDto;
  } catch (error) {
    console.error(error);
  }
};

service.save3DConfirmed = async (fileId, token) => {
  try {
    const response = await ThreeDRestService.update(
      {
        endpoint: 'confirmed',
        endpointParam: fileId,
      },
      {
        newState: 'READY',
        token: token ? token : storageService.getItem('token'),
      },
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.debug(error);
  }

  // try {
  //   // const response = await newGenericRestRequest(
  //   //   'put',
  //   //   VIDABOO_CONSTANTS.REST_PATHS.THREED +
  //   //     `/confirmed/${fileId}??newState=READY&token=${finalToken}`,
  //   // );
  //   // if (response.status === 200) {
  //   // }
  //   return response.data;
  // } catch (error) {
  //   console.error(error);
  // }
};

service.abortFetching = () => {
  if (service.controller) {
    service.controller.cancel();
  }
  return;
};

service.getBase64FromUrl = async (url, fileId, progress) => {
  try {
    service.controller = axios.CancelToken.source();

    return axios({
      method: 'get',
      url: url,
      responseType: 'blob',
      onDownloadProgress: (progressEvent) => {
        var percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total,
        );
        progress(percentCompleted);
      },
      cancelToken: service.controller.token,
    }).then((response) => {
      const blob = response.data;
      return blob;
      // return new Promise(async (resolve) => {
      //   const reader = new FileReader();

      //   reader.readAsDataURL(blob);
      //   reader.onloadend = () => {
      //     console.debug('onloadend', fileId);
      //     service.fileId = '';
      //     service.controller = null;
      //     const base64data = reader.result;
      //     resolve(base64data);
      //   };
      // });
    });
  } catch (e) {
    console.debug('Error:', e);
  }
};

service.updateThumbnailFileState = async (fileId, token) => {
  try {
    const response = await ThreeDRestService.update(
      {
        endpoint: 'thumbnail/confirmed',
        endpointParam: fileId,
      },
      {
        newState: 'READY',
        token: token ? token : storageService.getItem('token'),
      },
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
};

const threedService = {...service};
export default threedService;
